import { gql } from '@urql/core';

export const ME_QUERY = gql`
  query Me {
    me {
      id
      name
      first_name
      last_name
      infix
      roles {
        id
        type
        status
        role_data {
          ... on Advisor {
            type
            has_mandate
          }
        }
      }
    }
  }
`;
